export default __webpack_public_path__ + "static/media/dropdown.6dca3488.svg";